(() => {
  function init(){document.querySelectorAll('[data-flag-options]').forEach(root=>{
    if(root.dataset.liveReady)return;root.dataset.liveReady='true';
    const section=root.closest('[id^="MainProduct-"]');
    const form=section?.querySelector('form[data-type="add-to-cart-form"]');
    const monogram=section?.querySelector('[data-flag-monogram]');
    const button=form?.querySelector('[name="add"]');
    if(!form||!monogram||!button)return;
    form.noValidate=false;
    const variants=JSON.parse(root.querySelector('[data-flag-variants]').textContent);
    const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:root.dataset.currency||'USD'}).format(n/100);
    const selected=()=>{const color=root.querySelector('[data-flag-color]:checked')?.value;
      const tag=root.querySelector('[data-flag-tag]:checked')?.value;
      return variants.find(v=>v.options[0]===color&&v.options[1]===tag);};
    function update(){
      const variant=selected(),tag=root.querySelector('[data-flag-tag]:checked')?.value;
      root.querySelector('[data-flag-total]').textContent=money(variant?variant.price:Number(root.dataset.base));
      root.querySelector('[data-flag-breakdown]').textContent=!tag?'Please choose a Birth Tag option.':tag==='No Birth Tag'?'No Birth Tag: +$0.00':'Birth Tag: +$8.00 · '+tag;
      form.querySelector('[name="id"]').value=variant?variant.id:'';
      const ready=!!variant?.available&&/^[A-Z]{1,3}$/.test(monogram.value);
      button.disabled=!ready;
      button.dataset.flagPending=String(!ready);
      const label=variant&&!variant.available?'Sold out':ready?'Add to Cart':'Select the options above';
      button.querySelectorAll('.btn__texts__item').forEach(item=>item.textContent=label);
    }
    monogram.addEventListener('input',()=>{monogram.value=monogram.value.replace(/[^a-z]/gi,'').slice(0,3).toUpperCase();update();});
    root.addEventListener('change',update);
    form.addEventListener('submit',event=>{
      if(!form.reportValidity()||!selected()?.available){event.preventDefault();event.stopImmediatePropagation();}
    },true);
    update();
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
